import React, { useState, useEffect } from 'react';

const ConfigModal = ({ isOpen, onClose, onSave, initialData, translations, isAddMode }) => {
  const [formData, setFormData] = useState({
    key: '',
    value: '',
    description: '',
  });
  const [message, setMessage] = useState('');

  const t = translations;

  useEffect(() => {
    if (initialData) {
      setFormData({ ...initialData });
    } else {
      setFormData({
        key: '',
        value: '',
        description: '',
      });
    }
    setMessage('');
  }, [initialData, isOpen]);

  const validateFields = () => {
    const requiredFields = [
      'key',
      'value',
      'description',
    ];

    const missingFields = requiredFields.filter((field) => !formData[field] || formData[field].trim() === '');
    return missingFields;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage('');

    const missingFields = validateFields();
    if (missingFields.length > 0) {
      setMessage(`${t.missingFields} ${missingFields.map((field) => t[field]).join(', ')}`);
      return;
    }

    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isAddMode ? t.addConfig : t.configInfo}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {message && (
              <div className={`alert ${message.includes(t.missingFields) || message.includes(t.errorUpdate) ? 'alert-danger' : 'alert-success'}`}>
                {message}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label>{t.key}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.key}
                      onChange={(e) => setFormData({ ...formData, key: e.target.value })}
                      placeholder={t.placeholderKey}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label>{t.value}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.value}
                      onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                      placeholder={t.placeholderValue}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label>{t.description}</label>
                    <textarea
                      className="form-control"
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                      placeholder={t.placeholderDescription}
                      rows="3"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  {t.cancelButton}
                </button>
                <button type="submit" className="btn btn-primary">
                  {isAddMode ? t.addButton : t.saveButton}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigModal;
